
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  IntUserStatutHistory.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\IntUserStatutHistory.ts

import {IntUserStatut } from "./IntUserStatut";
import {IntUser } from "./IntUser";
export class IntUserStatutHistory {

  // int Id
  public Id: number=0;

  // int IntUserId
  public IntUserId: number=0;

  // int StatutId
  public StatutId: number=0;

  // DateTime DatMaj
  public DatMaj: Date= new Date();

  // int IntUserIdMaj
  public IntUserIdMaj: number=0;

  // string Comments
  public Comments?: string=null;

  // IntUserStatut IntUserStatut
  public IntUserStatut: IntUserStatut=null;

  // IntUser IntUser
  public IntUser: IntUser=null;
}